export enum ContentHeaderLayout {
  Secondary = 'secondary',
}
